import React, { useState, useEffect, Suspense, lazy } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ExploreApartments from './components/ExploreApartments';
import PromoBanner from './components/PromoBanner';
import Footer from './components/Footer';
import './styles/App.css';

const ApartmentDetail = lazy(() => import('./components/ApartmentDetail'));
const Location = lazy(() => import('./components/Location'));
const About = lazy(() => import('./components/About'));

function App() {
  const [currentSection, setCurrentSection] = useState('');
  const [selectedApartment, setSelectedApartment] = useState(null);

  useEffect(() => {
    // Get the hash from URL on mount and when hash changes
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the # symbol
      setCurrentSection(hash);
    };

    // Set initial section
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const handleApartmentClick = (apartmentId) => {
    setSelectedApartment(apartmentId);
  };

  const handleCloseDetail = () => {
    setSelectedApartment(null);
  };

  return (
    <div className="App">
      <Navbar onResidenceClick={handleApartmentClick} />
      {selectedApartment ? (
        <Suspense fallback={<div style={{ padding: '3rem', textAlign: 'center' }}>Loading…</div>}>
          <ApartmentDetail 
            apartmentId={selectedApartment} 
            onClose={handleCloseDetail}
          />
        </Suspense>
      ) : (
        <>
          {!currentSection && (
            <>
              <Hero />
              <ExploreApartments onApartmentClick={handleApartmentClick} />
              <PromoBanner />
            </>
          )}
          <main>
            {currentSection === 'about' && (
              <Suspense fallback={<div style={{ padding: '3rem', textAlign: 'center' }}>Loading…</div>}>
                <About />
              </Suspense>
            )}
            {currentSection === 'location' && (
              <Suspense fallback={<div style={{ padding: '3rem', textAlign: 'center' }}>Loading…</div>}>
                <Location />
              </Suspense>
            )}
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
